import { render, staticRenderFns } from "./Encounters.vue?vue&type=template&id=31d294fe&scoped=true"
import script from "./Encounters.vue?vue&type=script&lang=js"
export * from "./Encounters.vue?vue&type=script&lang=js"
import style0 from "./Encounters.vue?vue&type=style&index=0&id=31d294fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31d294fe",
  null
  
)

export default component.exports